import { useContext } from 'react';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useFacetData } from '~/context/srp/FacetDataContext';
import FilterDrawer from './FilterDrawer';
import useRangeUpdater from './hooks/useRangeUpdater';
import RangeSlider from './RangeSlider';
import useExpand from './useExpand';
import type WithClassName from './WithClassName';

export default function MPG({ className }: WithClassName) {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const [show, setShow] = useExpand(false);
  const facetData = useFacetData();

  const onUpdate = useRangeUpdater({
    filterKey: 'mpg',
    max: facetData.mpg?.max,
    min: facetData.mpg?.min
  });

  return (
    <FilterDrawer
      className={className}
      dataQa="facet-mpg"
      facetContent={facetData.mpg}
      facetName="MPG"
      show={show}
      onToggle={() => setShow(v => !v)}
    >
      <RangeSlider
        className="px-24 py-32"
        isShowing={show}
        id="facet-mpg"
        label="MPG/MPGe"
        dualRange
        min={facetData.mpg?.min}
        max={facetData.mpg?.max}
        initialValues={[
          appliedFilters.mpg?.min ?? facetData.mpg?.min ?? 0,
          appliedFilters.mpg?.max ?? facetData.mpg?.max ?? 0
        ]}
        onUpdate={onUpdate}
        labelTextTransform="none"
      />
    </FilterDrawer>
  );
}
